import React from 'react';
import type { ProviderDetail } from '../../../../../js/api';
import { CredentialSectionSpec } from './credentials';
import { DocumentSections } from './DocumentSections';
import { ProviderDrawerMaps } from './providerDisplay';

export { ExpirationDate, PROVIDER_UPDATE_PERMISSION } from './ProviderDrawerPrimitives';

type CredentialEntriesTabProps = {
  provider: ProviderDetail;
  maps: ProviderDrawerMaps;
  /** The sections this tab owns, in display order (the add bar follows the same order). */
  sections: readonly CredentialSectionSpec[];
  /** Prefix of every test id (`<prefix>-tab`, `<prefix>-add-bar`, `<prefix>-card-<id>`, ...). */
  testIdPrefix: string;
  /** What a zip of the tab's documents is called: "John Joe MD Licenses and Certifications Documents". */
  zipSubject: string;
  /** Shown when nothing is on file and the viewer may not add anything. */
  emptyText: string;
  loadingText: string;
  /** Rendered above the sections (the Licenses & Certs tab's IMLC line). */
  header?: React.ReactNode;
};

/**
 * A tab made only of credential ENTRY sections (`LicensesTab`: licenses, board and
 * life-support certifications; `ImmunizationsTab`): the shared `DocumentSections`
 * layout with no document types. A tab that mixes entries with document types (the
 * Education tab's ECFMG certificate) lists them together in `DocumentSections` directly.
 */
export function CredentialEntriesTab({
  provider,
  maps,
  sections,
  testIdPrefix,
  zipSubject,
  emptyText,
  loadingText,
  header,
}: CredentialEntriesTabProps) {
  return (
    <div className="tw:flex tw:flex-col tw:gap-4" data-testid={`${testIdPrefix}-tab`}>
      <DocumentSections
        providerId={provider.id}
        types={sections}
        maps={maps}
        testIdPrefix={testIdPrefix}
        zipSubject={zipSubject}
        emptyText={emptyText}
        loadingText={loadingText}
        header={header}
      />
    </div>
  );
}
